import * as React from "react"

import { IProduct } from "shared/hubrise/models"

import SkuOptionLists from "./SkuOptionLists"

interface SingleSkuProps {
  product: IProduct
}

const SingleSku = ({ product }: SingleSkuProps): JSX.Element => {
  const sku = product.skus[0]
  return <SkuOptionLists product={product} sku={sku} />
}

export default SingleSku
